export default __webpack_public_path__ + "static/media/email.5bc0619e.svg";